"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var xmldom_1 = require("@xmldom/xmldom");
var NodeTypes;
(function (NodeTypes) {
    NodeTypes[NodeTypes["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeTypes[NodeTypes["ATTRIBUTE_NODE"] = 2] = "ATTRIBUTE_NODE";
    NodeTypes[NodeTypes["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeTypes[NodeTypes["CDATA_SECTION_NODE"] = 4] = "CDATA_SECTION_NODE";
    NodeTypes[NodeTypes["ENTITY_REFERENCE_NODE"] = 5] = "ENTITY_REFERENCE_NODE";
    NodeTypes[NodeTypes["ENTITY_NODE"] = 6] = "ENTITY_NODE";
    NodeTypes[NodeTypes["PROCESSING_INSTRUCTION_NODE"] = 7] = "PROCESSING_INSTRUCTION_NODE";
    NodeTypes[NodeTypes["COMMENT_NODE"] = 8] = "COMMENT_NODE";
    NodeTypes[NodeTypes["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
    NodeTypes[NodeTypes["DOCUMENT_TYPE_NODE"] = 10] = "DOCUMENT_TYPE_NODE";
    NodeTypes[NodeTypes["DOCUMENT_FRAGMENT_NODE"] = 11] = "DOCUMENT_FRAGMENT_NODE";
    NodeTypes[NodeTypes["NOTATION_NODE"] = 12] = "NOTATION_NODE";
})(NodeTypes || (NodeTypes = {}));
var TextNodeConverterName = "$TextNode";
var XMLToReact = /** @class */ (function () {
    function XMLToReact(converters, options) {
        this._tagStack = undefined;
        this._converters = converters;
        this._parser = new xmldom_1.DOMParser({ errorHandler: function (msg) { throw new Error(msg); } });
        if (options && options.includeRawXmlAsProp)
            this._serializer = new xmldom_1.XMLSerializer();
        if (options && options.tagStackEnabled)
            this._tagStack = [];
    }
    XMLToReact.prototype.convert = function (xml, data) {
        if (typeof xml !== 'string')
            return null;
        var tree;
        try {
            tree = this._parser.parseFromString(xml, 'text/xml');
        }
        catch (e) {
            // tslint:disable-next-line:no-console
            console.warn('XMLToReact: Unable to parse invalid XML input. Please input valid XML.');
            return null;
        }
        var result = this._visitNode(tree.documentElement, 0, this._converters, data);
        if (typeof result === 'string')
            return null;
        return result;
    };
    XMLToReact.prototype._visitNode = function (node, index, converters, data) {
        var _this = this;
        if (!node)
            return null;
        var tagName = node.tagName;
        var nodeType = node.nodeType;
        if (nodeType === NodeTypes.TEXT_NODE)
            return this._convertTextNode(node, converters[TextNodeConverterName], index, data);
        if (this._tagStack)
            this._tagStack.push(tagName);
        if (!tagName)
            return null;
        var converter = converters[tagName];
        if (typeof converter !== 'function')
            return null;
        var attributes = this._getAttributes(node);
        var _converter = converter(attributes, data, this._tagStack);
        var type = _converter.type;
        var props = _converter.props;
        var newProps = __assign({ key: index, raw: this._serializer && this._serializer.serializeToString(node) }, props);
        var children = this._getChildren(node);
        var childElements = children.map(function (child, childIndex) {
            return _this._visitNode(child, childIndex, converters, data);
        });
        if (this._tagStack)
            this._tagStack.pop();
        return this._createElementFromConverterOutput(type, newProps, childElements);
    };
    XMLToReact.prototype._convertTextNode = function (node, converter, index, data) {
        if (!converter)
            return node.nodeValue;
        var _converter = converter(node.nodeValue, data);
        var type = _converter.type;
        var props = _converter.props;
        var newProps = __assign({ key: index, raw: this._serializer && node.nodeValue }, props);
        return this._createElementFromConverterOutput(type, newProps, null);
    };
    XMLToReact.prototype._createElementFromConverterOutput = function (type, props, childElements) {
        var children = (childElements && this._toConsumableArray(childElements)) || [];
        return react_1.default.createElement.apply(undefined, __spreadArray([type, props], children, true));
    };
    XMLToReact.prototype._getAttributes = function (node) {
        if (!node)
            return {};
        var attributes = node.attributes;
        if (!attributes || !attributes.length)
            return {};
        return Array.from(attributes).reduce(function (results, attr) {
            /* tslint:disable:no-string-literal */
            var name = attr['name'];
            /* tslint:disable:no-string-literal */
            var value = attr['value'];
            results[name] = value;
            return results;
        }, {});
    };
    XMLToReact.prototype._getChildren = function (node) {
        if (!node)
            return [];
        var children = node.childNodes;
        if (!children)
            return [];
        return children.length ? Array.from(children) : [];
    };
    XMLToReact.prototype._toConsumableArray = function (arr) {
        if (Array.isArray(arr))
            return __spreadArray([], arr, true);
        else
            return Array.from(arr);
    };
    return XMLToReact;
}());
exports.default = XMLToReact;
